export * from './basicFormatter';
export * from './numberFormatter';
export * from './decimalFormatter';
export * from './percentageFormatter';
export * from './currencyFormatter';
export * from './dayFormatter';
export * from './weekFormatter';
export * from './monthFormatter';

import { basicFormatter } from './basicFormatter';
import { currencyFormatter } from './currencyFormatter';
import { dayFormatter } from './dayFormatter';
import { decimalFormatter } from './decimalFormatter';
import { monthFormatter } from './monthFormatter';
import { numberFormatter } from './numberFormatter';
import { percentageFormatter } from './percentageFormatter';
import { weekFormatter } from './weekFormatter';

export const FORMATTER = {
  basic: basicFormatter,
  number: numberFormatter,
  decimal: decimalFormatter,
  percentage: percentageFormatter,
  currency: currencyFormatter,
  day: dayFormatter,
  week: weekFormatter,
  month: monthFormatter,
};
